import React from "react";
import { X } from "lucide-react";
import { useCart } from "./LandingLayout";
import { NotifyBack } from "./NotifyBack";
import { toast } from "sonner";

export function ProductModal({ product, onClose }) {
  const { addToCart } = useCart();
  if (!product) return null;
  const soldOut = product.stock === 0;
  const low = product.stock > 0 && product.stock <= 5;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      data-testid="product-modal"
    >
      <div
        className="relative max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-3xl bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          data-testid="product-modal-close"
          className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-neutral-700 shadow hover:bg-white"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="grid gap-0 md:grid-cols-2">
          <div className="flex items-center justify-center bg-[#f3ece8] p-4">
            {product.image ? (
              <img
                src={product.image}
                alt={product.name}
                className="max-h-[70vh] w-full rounded-2xl object-contain"
              />
            ) : (
              <div className="flex h-72 w-full items-center justify-center text-[11px] uppercase tracking-[0.3em] text-neutral-400">
                Lash Dollz
              </div>
            )}
          </div>
          <div className="flex flex-col p-6">
            <h2 className="text-xl font-medium tracking-tight text-neutral-900" data-testid="product-modal-name">
              {product.name}
            </h2>
            <div className="mt-2 flex items-center gap-3">
              <span className="text-lg font-medium text-neutral-900">
                €{Number(product.price || 0).toFixed(2)}
              </span>
              {soldOut && (
                <span className="text-[11px] font-medium uppercase tracking-[0.2em] text-red-500">Sold out</span>
              )}
              {low && (
                <span className="text-[11px] font-medium uppercase tracking-[0.2em] text-amber-600">
                  Only {product.stock} left
                </span>
              )}
            </div>
            {product.description && (
              <p className="mt-4 text-sm leading-relaxed text-neutral-600" data-testid="product-modal-description">
                {product.description}
              </p>
            )}
            <div className="mt-auto pt-6">
              <button
                type="button"
                data-testid="product-modal-add"
                disabled={soldOut}
                onClick={() => {
                  if (soldOut) return;
                  addToCart({ id: product.id, name: product.name, price: Number(product.price) });
                  toast.success(`${product.name} added to cart`);
                  onClose();
                }}
                className="inline-flex h-11 w-full items-center justify-center rounded-full bg-black px-8 text-[11px] font-medium uppercase tracking-[0.25em] text-white transition-colors hover:bg-neutral-800 disabled:cursor-not-allowed disabled:bg-neutral-300"
              >
                {soldOut ? "Sold out" : "Add to cart"}
              </button>
              {soldOut && <NotifyBack productId={product.id} testidPrefix="modal-notify" />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
